var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "9px",
    viewBox: "0 0 15 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "66228E7A-4B48-4D74-AECB-CB9661760638") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-1-4-DhurvStar-Design-System",
    transform: "translate(-322.000000, -406.000000)",
    fill: "#292929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.-Icons/ic_chevron_down",
    transform: "translate(322.000000, 406.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.979445,-2.96830418 L11.0347806,-2.96746296 C11.1452493,-2.95928375 11.2532618,-2.91214271 11.3364563,-2.82637979 C11.5028451,-2.65485395 11.5118002,-2.38879754 11.3660412,-2.20710563 L11.3263798,-2.16354377 L4.479375,4.4775 L4.47322705,4.48777598 C4.4716001,4.49160378 4.47073702,4.49575625 4.47073702,4.5 L4.47336198,4.51235449 L4.48137976,4.52354375 L11.3263798,11.1635438 C11.5121994,11.3437983 11.5167108,11.6405601 11.3364563,11.8263798 C11.1700674,11.9979056 10.9044062,12.014944 10.7183676,11.8747752 L10.6736202,11.8364563 L3.82969965,5.1975 C3.64025877,5.01490687 3.53323702,4.76311233 3.53323702,4.5 C3.53323702,4.26612237 3.61779742,4.0411872 3.76888088,3.86658105 L3.82862022,3.80354375 L10.6736202,-2.83645627 C10.7450893,-2.90578495 10.83297,-2.94778139 10.9243213,-2.96264231 L10.979445,-2.96830418 Z",
    id: "Combined-Shape",
    transform: "translate(7.500994, 4.500223) scale(1, -1) rotate(90.000000) translate(-7.500994, -4.500223) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronDown);
export default __webpack_public_path__ + "static/media/ic_chevron_down.f96034508067476c8b5b2b8a09d460e4.svg";
export { ForwardRef as ReactComponent };